(function () {
  if (!['destructive-staging.myshopify.com', 'dsrcv.com', 'www.dsrcv.com', 'dsrcv.myshopify.com'].includes(location.hostname)) return;

  var themeId = location.hostname === 'destructive-staging.myshopify.com' ? '208998072645' : '187352842618';

  function bindDisclosure(details) {
    details.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !details.open) return;
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      details.querySelector('summary').focus();
    });
  }

  function init() {
    var details = document.querySelector('[data-bf-product-services][data-theme-id="' + themeId + '"]');
    if (!details) return;
    if (details.dataset.bound === 'true') return;
    details.dataset.bound = 'true';
    bindDisclosure(details);

    // Staging has no connected rewards programme. Rehearse the currently
    // verified UK 10% earning rate without changing provider data or balances.
    if (location.hostname !== 'destructive-staging.myshopify.com' || details.dataset.currency !== 'GBP') return;
    var source = document.getElementById('stamped-rewards-points-placeholder-element');
    var label = document.querySelector('[data-product-reward-money]');
    if (!source || !label) return;
    var prices;
    try { prices = JSON.parse(source.dataset.variantPrices); } catch (error) { return; }
    var keys = Object.keys(prices);
    if (!keys.length || keys.some(function (key) { return typeof prices[key] !== 'number' || !Number.isFinite(prices[key]) || prices[key] <= 0; })) return;
    var uniform = keys.every(function (key) { return prices[key] === prices[keys[0]]; });
    var selected = details.dataset.selectedVariant || '';
    var fallback = details.dataset.rewardFallback;
    var template = details.dataset.rewardCopy;
    if (!template || template.indexOf('[[amount]]') < 0) return;

    function update() {
      var price = uniform ? prices[keys[0]] : prices[selected];
      var copy = fallback;
      if (typeof price === 'number' && Number.isFinite(price) && price > 0) {
        var reward = Math.round(price * 0.1) / 100;
        var amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: 'GBP', minimumFractionDigits: reward % 1 ? 2 : 0, maximumFractionDigits: 2
        }).format(reward);
        copy = template.split('[[amount]]').join(amount);
      }
      if (label.textContent !== copy) label.textContent = copy;
    }
    function variantChanged(event) {
      var detail = event.detail || {};
      selected = String(detail.id || detail.variant && detail.variant.id || '');
      update();
    }
    var observer = new MutationObserver(update);
    observer.observe(label, { childList: true, characterData: true, subtree: true });
    document.addEventListener('variant:changed', variantChanged);
    window.addEventListener('pagehide', function () {
      observer.disconnect();
      document.removeEventListener('variant:changed', variantChanged);
    }, { once: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('currency:change', init);
  document.addEventListener('covCurrency:updated', init);
  document.addEventListener('country:change', init);
}());
